import React, { useState } from "react";
import { PlusCircleOutlined, SettingOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

import {
    Row,
    Typography,
    Col,
    Button,
    Tooltip,
    Table,
    Collapse,
    Dropdown,
} from "antd";
import { apiConfig, labelConfig, staticConfig } from "../../group.config";

const { Title, Text } = Typography;
const { Panel } = Collapse;

function ManageMembers(props) {
    const { clientsList, manageClientsMenuProps } = props;

    const columns = [
        {
            title: " Account Number",
            dataIndex: "accountNo",
        },
        {
            title: "Name",
            dataIndex: "name",
        },
        {
            title: "Status",
            dataIndex: "status",
          },
        {
            title: "Actions",
            render: () => (
                <>
                    <Tooltip title={`JLG Loan Application`}>
                        <Button
                            type="primary"
                            icon={<PlusCircleOutlined />}
                            shape="round"
                            size="small"
                            className="of-primaryBtnColor"
                        />
                    </Tooltip>
                </>
            ),
        },
    ];


    return (
        <>
            <Row style={{ marginBottom: 30, padding: 10 }}>
                <Col span={12} style={{ padding: "0px 8px" }}>
                    <Dropdown.Button
                        menu={manageClientsMenuProps}
                        icon={<SettingOutlined />}
                        placement="topLeft"
                    >
                        Actions
                    </Dropdown.Button>
                </Col>
            </Row>
            <Row style={{ marginBottom: 30, padding: 10 }}>

                <Col span={24} style={{ padding: "0px 8px" }}>
                    <Table columns={columns}
                        dataSource={clientsList}
                    />
                </Col>
            </Row>
        </>
    );
}

export default ManageMembers;
